import dynamic from "next/dynamic";

export const dynamicImport = (componentName: string) =>
    dynamic(
        () =>
            import("@seismic/mantle").then(
                (mod) => mod[componentName] as React.ForwardRefExoticComponent<any>
            ),
        { ssr: false }
    );